








































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { SearchBoxMixin } from '../../mixins/search-box.mixin';

@Component
export default class AutoCompleteSearchBox extends Mixins(SearchBoxMixin) {

  @Prop()
  suggestion: string;

  @Prop({ default: true })
  autoCompleteEnabled: boolean;

  @Prop({ default: 64 })
  maxLength: number;

  get showSuggestion() {
    return this.inputFocused && this.value && this.suggestion;
  }

  acceptSuggestion(event: Event) {
    if (this.autoCompleteEnabled && this.suggestion) {
      event.preventDefault();
      this.$x.emit(EVENTS.AutoCompleteSuggestionSelected, this.suggestion);
    }
  }
}
